import { CheckCircle, Star } from 'lucide-react';
import { IslamicSymbol } from '../ui/islamic-symbol';
import { useLanguage } from '../../contexts/LanguageContext';

export function HeroSection() {
  const { t } = useLanguage();
  return (
    <section className="bg-gradient-to-br from-[#f91bdc]/10 via-white to-[#f91bdc]/5 pt-8 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            {t('hero.title')}{' '}
            <span className="text-[#f91bdc]">{t('hero.subtitle')}</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            {t('hero.description')}
          </p>
          <div className="flex items-center justify-center space-x-4 text-gray-500 mb-8">
            <div className="flex items-center space-x-2">
              <IslamicSymbol size={20} className="text-[#f91bdc]" />
              <span>{t('hero.shariahCompliant')}</span>
            </div>
            <div className="w-1 h-1 bg-gray-300 rounded-full"></div>
            <div className="flex items-center space-x-2">
              <CheckCircle size={20} className="text-[#f91bdc]" />
              <span>{t('hero.transparentPricing')}</span>
            </div>
            <div className="w-1 h-1 bg-gray-300 rounded-full"></div>
            <div className="flex items-center space-x-2">
              <Star size={20} className="text-[#f91bdc]" />
              <span>{t('hero.quickApproval')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}